import type { BuildInfo } from '@/types/system'

import { api } from './client'

export const systemApi = {
  getBuildInfo: () =>
    api.get<BuildInfo>('/_version'),
}
